import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';
import { Button } from '@spotahome/ui-library';
import '@spotahome/ui-library/lib/components/Button.css';

import './NoResultsMessage.scss';

const RenderTypeOfResultsMessage = props => {
  let content = null;

  if (!props.totalResults) {
    content = (
      <Fragment>
        <div className="search-no-results__text">
          {trans('search.no_results.text_filters')}
        </div>
        <div className="search-no-results__cta">
          <Button onClick={props.clearExtendedFilters}>
            {trans('search.no_results.cta_filters')}
          </Button>
        </div>
      </Fragment>
    );
  } else if (!props.results) {
    content = (
      <Fragment>
        <div className="search-no-results__text">
          {trans('search.no_results.text_map')}
        </div>
        <div className="search-no-results__cta">
          <Button onClick={props.centerResultsInMap}>
            {trans('search.no_results.cta_map')}
          </Button>
        </div>
      </Fragment>
    );
  }

  return content;
};

const NoResultsMessage = props => (
  <div className="search-no-results">
    <strong className="search-no-results__title">
      {trans('search.no_results.title')}
    </strong>
    <RenderTypeOfResultsMessage {...props} />
  </div>
);

RenderTypeOfResultsMessage.propTypes = {
  totalResults: PropTypes.number.isRequired,
  results: PropTypes.number.isRequired,
  clearExtendedFilters: PropTypes.func.isRequired,
  centerResultsInMap: PropTypes.func.isRequired
};

export default NoResultsMessage;
